module.exports = __webpack_public_path__ + "img/face-with-raised-eyebrow.54641057.svg";